<template>
    <div>
        <el-dialog width="1100px" title="选择资产" :visible.sync="dialogVisible" :close-on-click-modal="false" :append-to-body="true">
            <div style="display: flex">
                <div class="tree_box">
                    <GiantTree :nodes="treeData" @onClick="onTreeNodeClick" @onCreated="onTreeCreated" />
                </div>
                <div class="table_box" style="width: 100%">
                    <div style="display: flex; justify-content: space-between; margin-bottom: 10px">
                        <el-input v-model="searchObj.title" placeholder="请输入关键词搜索" style="width: calc(100% - 140px)">
                            <el-button slot="append" icon="el-icon-search" @click.native="getData"></el-button>
                        </el-input>
                        <el-button type="primary" @click.native="submitHandler">选择(已选{{ multipleSelection.length }}个)</el-button>
                    </div>
                    <el-table v-loading="tableLoading" :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="55" align="center"></el-table-column>
                        <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
                        <el-table-column prop="assetCode" label="资产编号" width="140" align="center" :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column prop="assetName" label="资产名称" align="left" :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column prop="assetModel" label="规格型号" width="140" align="center" :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column prop="unit" label="单位" width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column prop="option" label="操作" width="80" align="center">
                            <template slot-scope="scope">
                                <el-link type="primary" :underline="false" @click="selectAsset(scope.row)">选择</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="text-align: right; margin-top: 10px">
                        <el-pagination :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button icon="el-icon-close" @click="dialogVisible = false">取 消</el-button>
                <el-button icon="el-icon-check" type="primary" @click="submitHandler">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    components: {},
    props: {
        vo: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            dialogVisible: false,
            treeData: [],
            moduleInfo: {
                moduleCode: 'Module',
                addNewUrl: '/zcgl/config/assetType/addNew', // 新增保存类型信息url
                insertUrl: '/zcgl/config/assetType/insert', // 新增保存类型信息url
                updateUrl: '/zcgl/config/assetType/update', // 修改保存类型信息url
                delUrl: '/zcgl/config/assetType/delete', // 删除类型信息url
                winWidth: 900, // 查看、编辑模块菜单窗口宽度
                winHeight: 600, // 查看、编辑模块菜单窗口高度
                getByIdUrl: '/zcgl/config/assetType/getById',
                loadTreeNodeUrl: '/zcgl/config/assetType/querydata' // 加载类型树节点
            },
            root: null,
            tableData: [],
            tableLoading: false,
            pageNum: 1,
            pageSize: 10,
            total: 0,
            searchObj: {
                title: ''
            },
            multipleSelection: [], // 选择的数据
            callback: null,
            ids: '',
            selectTreeId: '',
            assetStatus: ''
        }
    },
    computed: {
        ...mapGetters(['loginUser'])
    },
    watch: {},
    created() {
        this.root = { id: 'sys', name: '资产分类', open: true, title: '资产分类' }
        this.$bus.on('openAssetsDialog', this.openAssetsDialog)
    },
    beforeDestroy() {
        this.$bus.off('openAssetsDialog', this.openAssetsDialog)
    },
    mounted() {},
    methods: {
        openAssetsDialog(list, assetStatus, callback) {
            this.assetStatus = assetStatus
            this.callback = callback
            if (list.length) {
                this.ids = list.map((item) => item.assetId).join(',')
            }
            this.dialogVisible = true
            this.loadTypeTree()
            this.getTableDate()
        },
        // 选择资产
        selectAsset(row) {
            this.multipleSelection = [row]
            if (this.callback) {
                this.callback(this.multipleSelection)
            }
            this.dialogVisible = false
        },
        // 确定
        submitHandler() {
            if (this.callback) {
                this.callback(this.multipleSelection)
            }
            this.dialogVisible = false
        },
        getData() {
            this.getTableDate()
        },
        async getTableDate() {
            this.tableLoading = true
            var searchMap = {}
            searchMap['assetCode'] = this.searchObj.title
            searchMap['assetName'] = this.searchObj.title
            searchMap['assetModel'] = this.searchObj.title
            searchMap['unit'] = this.searchObj.title
            const data = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                searchAndOr: 'or',
                searchMap: searchMap,
                urlsearch: `id!:${this.ids};typeId like ${this.selectTreeId};assetStatus:${this.assetStatus};status:1`
            }
            const res = await this.$app.listdata('zcgl/manage/assetInfo/listdata', data)
            if (res.code === 'success') {
                this.total = res.body.pageInfo.total
                this.tableData = res.body.pageInfo.list
            }
            this.tableLoading = false
        },
        loadTypeTree() {
            // 加载类型节点数据
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                params: { orderBy: 'orderNo asc' },
                data: [{ compare: '=', field: 'orgCode', merge: true, value: this.loginUser.orgCode }],
                url: this.moduleInfo.loadTreeNodeUrl
            }).then((res) => {
                if (res.code === 'success') {
                    this.treeData = this.treeDataAdapter([this.root].concat(res.body.listdata))
                } else {
                    this.$alert(res.message, '操作提示', { type: 'error' })
                }
            })
        },
        refreshTreeData(treeData) {
            if (treeData === null) {
                this.loadTypeTree()
            } else {
                this.treeData = this.treeDataAdapter([this.root].concat(treeData))
            }
        },
        treeDataAdapter(treeData) {
            treeData.forEach((node) => {
                if (node.parentId === null) {
                    node.pId = this.root.id
                } else if (node.parentId !== undefined && node.parentId !== null) {
                    node.pId = node.parentId
                    node.title = node.name
                } else {
                    node.title = node.name
                }
            })
            // treeData格式必须遵循ztreeview treeNode规范
            return treeData
        },
        onTreeCreated(zTree) {
            this.zTree = zTree
            const treenodes = zTree.getNodes()
            if (treenodes.length === 0) {
                return false
            }
            if (treenodes[0].children === undefined) {
                this.onTreeNodeClick('', treenodes[0].id, treenodes[0]) // 获取节点数据
                zTree.selectNode(treenodes[0]) // 选中当前节点
                treenodes[0].tlevel = 1
            } else if (treenodes[0].children.length >= 1) {
                this.onTreeNodeClick('', treenodes[0].id, treenodes[0]) // 获取节点数据
                zTree.selectNode(treenodes[0]) // 选中当前节点
            } else {
                this.onTreeNodeClick('', treenodes[0].id, treenodes[0]) // 获取节点数据
                zTree.selectNode(treenodes[0]) // 选中当前节点
                treenodes[0].tlevel = 1
            }
        },
        onTreeNodeClick(evt, treeId, treeNode) {
            this.level = treeNode.level
            this.nodeName = treeNode.name
            // 菜单树点击事件
            const rootVo = JSON.parse(JSON.stringify(this.root))
            this.root = null
            this.selectTreeId = treeNode.id
            if (this.selectTreeId === 'sys') {
                this.selectTreeId = ''
            }
            this.getTableDate()
            this.$nextTick((res) => {
                if (treeNode.id === 'sys') {
                    this.vo = rootVo
                } else {
                    this.vo = treeNode
                }
                this.root = rootVo
            })
        },
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.getTableDate()
        },
        handleCurrentChange(val) {
            this.pageNum = val
            this.getTableDate()
        }
    }
}
</script>

<style scoped lang="scss">
/deep/ .el-cascader-menu__wrap {
    height: 408px;
}
/deep/ .el-cascader-menu:nth-child(3) {
    border-right: 0px solid #e4e7ed !important;
}
/deep/ .el-dialog__body {
    padding: 5px 20px;
}
/deep/ .el-cascader-panel.is-bordered {
    margin-bottom: 20px;
}
.tree_box {
    width: 200px;
    min-height: 400px;
    height: 100%;
    border: 1px solid #dee2e6;
    margin-right: 15px;
}
</style>

